import FileFunctions from "./functions/file_functions"
import Details from "./detailes/details";
import InfoBunners from "./info/info_bunners";

const FileHeader = () => {
  return (
    <div className="navbar navbar-expand-lg navbar-light bg-light"
      style={{
        position: 'sticky',
        top: '0',
        justifyContent: 'space-between',
        padding: '11px 23px 0 23px',
        height: '200px'
      }}>
      <Details />
      <InfoBunners />
      <FileFunctions />
    </div>
  );
};

export default FileHeader;